module.exports = __webpack_public_path__ + "img/gjjhpc.e871850b.svg";